import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import { CdkDrag, CdkDragEnd } from "@angular/cdk/drag-drop";
import { CommonModule, NgStyle } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { BackendApiService } from "../../../../app/services/backend-api.service";
import { PowerTrainService } from "../../../../app/services/powertrain.service";
import { BaseUrlConstantsService } from "../../../../app/services/base-url-constants.service";
import { PowertrainModalComponent } from "../../powertrain-modal/powertrain-modal.component";
import { MatButtonModule } from "@angular/material/button";
import { FileUploadComponent } from "../../powertrain/file-upload/file-upload.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { PiezeoService } from "../../../../app/services/piezeo.service";

@Component({
  selector: "app-piezeo-create",
  templateUrl: "./piezeo-edit.component.html",
  styleUrls: ["./piezeo-edit.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    NgStyle,
    PowertrainModalComponent,
    CdkDrag,
    FileUploadComponent,
    MatButtonModule,
  ],
})
export class PiezeoEditComponent implements OnInit {
  @ViewChild("canvasContainer") canvasContainer!: ElementRef;
  imagesUrl = BaseUrlConstantsService.POWERTRAIN_IMAGES_API;

  selectedAsset: any = {};
  selectedSensor: any = {};
  openModal: boolean = false;
  isUploadModalOpen = false;
  sidebarCollapsed: boolean = false;

  powerTrainImages = [];
  powertrainImageLoader: boolean = false;
  sensors: any = [];
  canvasItems: any = [];
  oldTemplateSensorNumber: number = 0;

  powertrainCanvasItems: any = [];
  powertrainSensors: any = [];
  powertrainSelectedSensor: any = {};
  openPowertrainSensorModal: boolean = false;
  isPowerTrain: boolean = true;
  powerTrainSensorsNumber: number = 0;

  openPowertrainNameModal: boolean = false;
  powertrainName: string = "";
  subsystem_id: number;
  group_id: number;
  site_id: any;
  app_id: any;

  constructor(
    private router: Router,
    private service: BackendApiService,
    private powertrainService: PowerTrainService,
    private snackBar: MatSnackBar,
    private piezeoService: PiezeoService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    const { Image_path, subsystem_name, device_position, id, subsystem_uuid, application_id, site_id } = this.route.snapshot.params;
    this.powertrainName = subsystem_name;
    this.addImageToPowerTrainCanvas({
      image_path: Image_path,
      image_alt: subsystem_name,
    });
    this.powertrainCanvasItems[0].sensors = JSON.parse(device_position);
    this.fetchPowertrainImages();
    this.powerTrainSensorsNumber = this.powertrainCanvasItems[0].sensors.reduce((max, s) => Math.max(max, s.sensor_number ?? -1), -1) + 1;
    this.subsystem_id = parseInt(id);
    this.group_id = subsystem_uuid;
    this.app_id = application_id;
    this.site_id = site_id;
  }

  ngAfterViewInit(): void {
    this.observeContainerResize();
  }

  toggleSidebar(): void {
    this.sidebarCollapsed = !this.sidebarCollapsed;
  }

  observeContainerResize(): void {
    const canvasContainer = this.canvasContainer.nativeElement;
    const observer = new ResizeObserver(() => {
      this.adjustPositionsOnResize();
    });
    observer.observe(canvasContainer);
  }

  adjustPositionsOnResize(): void {
    const canvasRect =
      this.canvasContainer.nativeElement.getBoundingClientRect();

    this.canvasItems.forEach((item: any) => {
      item.xPercent = (item.x / canvasRect.width) * 100;
      item.yPercent = (item.y / canvasRect.height) * 100;
    });

    this.sensors.forEach((sensor: any) => {
      sensor.xPercent = (sensor.x / canvasRect.width) * 100;
      sensor.yPercent = (sensor.y / canvasRect.height) * 100;
    });
  }

  addImageToCanvas(image: {
    src: string;
    alt: string;
    asset_type: string;
    sub_type: string | null | undefined;
  }): void {
    if (image.asset_type == "MOTOR") {
      {
        this.openModal = true;
      }
    }
    if (!this.canvasItems.length) {
      this.canvasItems.push({
        id: this.canvasItems.length,
        ...image,
        xPercent: 10,
        yPercent: 10,
        x: 0,
        y: 0,
        widthPercent: 20,
        sensors: [],
        asset_marker: "MASTER",
      });
    } else {
      this.canvasItems.push({
        id: this.canvasItems.length,
        ...image,
        xPercent: 10,
        yPercent: 10,
        x: 0,
        y: 0,
        widthPercent: 20,
        sensors: [],
        asset_marker: "CHILD",
      });
    }
  }

  onDragEnd(event: CdkDragEnd, item: any): void {
    const canvasRect =
      this.canvasContainer.nativeElement.getBoundingClientRect();
    const { x, y } = event.source.getFreeDragPosition();

    item.xPercent = Math.min(Math.max((x / canvasRect.width) * 100, 0), 100);
    item.yPercent = Math.min(Math.max((y / canvasRect.height) * 100, 0), 100);
    item.x = x;
    item.y = y;
  }

  // Handle Drag End for Sensors
  onSensorDragEnd(event: CdkDragEnd, sensor: any): void {
    const { x, y } = event.source.getFreeDragPosition();
    sensor.x = x;
    sensor.y = y;
  }

  // Add a Sensor to the Canvas
  addSensor(): void {
    if (!this.selectedAsset.asset_type) {
      this.openSnackBar("Please select an asset in canvas", "error-snackbar");
      return;
    }
    this.oldTemplateSensorNumber++;
    let selectedAss = this.canvasItems.filter(
      (item: any) => item.id == this.selectedAsset.id
    );
    this.sensors.push({
      id: this.sensors.length,
      sensor_number: this.sensors.length,
      xPercent: 10,
      yPercent: 10,
      width: 5,
      ...selectedAss[0],
    });

    selectedAss[0].sensors.push({
      id: this.sensors.length - 1,
      sensor_number: this.sensors.length - 1,
      xPercent: 10,
      yPercent: 10,
      width: 5,
      asset_marker: this.sensors.length - 1 == 0 ? "MASTER" : "CHILD",
    });
  }

  // Save Template
  saveTemplate(): void {
    let finalSensors = [];
    this.canvasItems.map((item) => {
      item.sensors.map((sensor) => {
        finalSensors.push({
          ...sensor,
          configured: false,
          associated: false,
          assetType: item.asset_type,
          subType: item.sub_type,
        });
      });
    });
    let subsystemEncodedData = encodeURIComponent(
      JSON.stringify({
        subsystem_name: this.powertrainName,
        client_id: localStorage.getItem("user_id"),
        Image_path: "",
        // subsystem_uuid: localStorage.getItem("assetBatchID") || "",
        site_id: JSON.parse(localStorage.getItem("siteID")),
        application_id: JSON.parse(localStorage.getItem("applicationID")),
        subsystem_type: "asset",
      })
    );
    finalSensors.sort((a, b) => a.sensor_number - b.sensor_number);
    const encodedCanvasItems = encodeURIComponent(JSON.stringify(finalSensors));
    const encodedJson = encodeURIComponent(JSON.stringify(this.canvasItems));
    this.router.navigate(["/powertrain-create-form"], {
      queryParams: {
        data: encodedCanvasItems,
        type: "Create Asset",
        assetType: "asset",
        jsonData: encodedJson,
        subsytemTableData: subsystemEncodedData,
      },
      skipLocationChange: true,
    });
  }

  onSensorClick(sensor) {
    this.selectedSensor = sensor;
    sensor.clickCount = (sensor.clickCount || 0) + 1;
    setTimeout(() => {
      if (sensor.clickCount === 3) {
        this.deleteCanvasItem(sensor);
      }
      sensor.clickCount = 0;
    }, 300);
  }

  onCanvasItemClick(item: any): void {
    this.selectedAsset = item;
    item.clickCount = (item.clickCount || 0) + 1;

    setTimeout(() => {
      if (item.clickCount === 3) {
        this.deleteCanvasItem(item);
      }
      item.clickCount = 0;
    }, 300);
  }

  // Function to delete an item from the canvas
  deleteCanvasItem(item: any): void {
    const index = this.canvasItems.indexOf(item);
    if (index !== -1) {
      this.canvasItems.splice(index, 1);
    }
  }

  deleteCanvasSensor() {
    if (this.isPowerTrain) {
      this.powerTrainSensorsNumber == 0
        ? this.snackBar.open("No sensors added yet", "error-snackbar")
        : (this.powertrainCanvasItems[0].sensors = []);
      this.powerTrainSensorsNumber = 0;
    } else {
      this.sensors.length
        ? (this.sensors = [])
        : this.snackBar.open("No sensors added yet", "error-snackbar");

      this.canvasItems.forEach((item) => {
        item.sensors = [];
      });
    }
  }

  closeBox(data) {
    this.openModal = false;
    this.canvasItems[this.canvasItems.length - 1].sub_type = data.type;
  }

  /* --------------------------------------------------------------------POWERTRAIN DRAG DROP START */

  addImageToPowerTrainCanvas(image: {
    image_path: string;
    image_alt: string;
  }): void {
    this.powertrainCanvasItems = [
      {
        id: this.powertrainCanvasItems.length,
        ...image,
        xPercent: 10,
        yPercent: 10,
        x: 0,
        y: 0,
        widthPercent: 20,
        sensors: [],
      },
    ];
    console.log(this.powertrainCanvasItems);
  }

  updatePowertrainImage(image: {
    image_path: string;
    image_alt: string;
  }): void {
    this.powertrainCanvasItems[0] = { ...this.powertrainCanvasItems[0], ...image }
    console.log(this.powertrainCanvasItems)
  }

  addPowerTrainSensor() {
    this.openPowertrainSensorModal = true;
  }

  closePowerTrainSensorBox(data) {
    if (!data) {
      this.openPowertrainSensorModal = false;
    } else {
      this.openPowertrainSensorModal = false;
      this.powertrainCanvasItems[0].sensors.push({ ...data, x: 0, y: 0 });
      this.powerTrainSensorsNumber++;
    }
  }

  deleteCurrentPowertrainSensor() {
    this.powerTrainSensorsNumber =
      this.powerTrainSensorsNumber == 1 ? 0 : this.powerTrainSensorsNumber - 1;
    this.powertrainCanvasItems[0].sensors =
      this.powertrainCanvasItems[0].sensors.filter(
        (sensor) =>
          sensor.sensor_number !== this.powertrainSelectedSensor.sensor_number
      );
    this.powertrainSelectedSensor = {};
  }

  onPowertrainSensorClick(item, i) {
    this.powertrainSelectedSensor = item.sensors[i];
  }

  savePowerTrainTemplate() {
    console.log('IM CALLED')
    let finalSensors = [];

    this.powertrainCanvasItems.map((item) => {
      item.sensors.map((sensor) => {
        console.log(sensor);
        finalSensors.push({
          ...sensor,
          xPercentage: sensor.xPercentageNet,
          yPercentage: sensor.yPercentageNet,
          xPercentages: sensor.xPercentageNet,
          yPercentages: sensor.yPercentageNet,
          associated: sensor.associated ? sensor.associated : false,
          configured: sensor.configured ? sensor.configured : false,
          form_configured: sensor.form_configured ? sensor.form_configured : false,
          is_new: sensor.form_configured ? false : true
        });
      });
    });
    finalSensors.sort((a, b) => a.sensor_number - b.sensor_number);
    // const encodedCanvasItems = encodeURIComponent(JSON.stringify(finalSensors));
    this.piezeoService.setData({
      data: finalSensors,
      suybsystem_table_data: {
        subsystem_name: this.powertrainName,
        client_id: localStorage.getItem("user_id"),
        Image_path: this.powertrainCanvasItems[0].image_path,
        subsystem_type: "piezeo",
        subsystem_id: this.subsystem_id,
        group_id: this.group_id,
        application_id: this.app_id,
        site_id: this.site_id
      },
    });
    this.piezeoService.setAllSensors(finalSensors.filter(s => s.master_type == 4));
    this.piezeoService.setEmsaverSensors(finalSensors.filter(s => s.master_type != 4))
    this.router.navigate(["/piezeo-edit-form"], {
      skipLocationChange: true,
    });
  }

  // onPowertrainSensorDragEnd(event: CdkDragEnd, sensor: any): void {

  //   const sensorEl = event.source.element.nativeElement as HTMLElement;

  //   // IMPORTANT: remove transform so DOM position is real
  //   sensorEl.style.transform = 'none';

  //   // Parent image
  //   const assetElement = sensorEl
  //     .closest('.powertrain-item')
  //     ?.querySelector('img') as HTMLElement;

  //   if (!assetElement) {
  //     console.error('Image element not found');
  //     return;
  //   }

  //   const imageRect = assetElement.getBoundingClientRect();
  //   const sensorRect = sensorEl.getBoundingClientRect();

  //   // Calculate relative position
  //   const x = sensorRect.left - imageRect.left;
  //   const y = sensorRect.top - imageRect.top;

  //   // Convert to %
  //   const xPercentage = (x / imageRect.width) * 100;
  //   const yPercentage = (y / imageRect.height) * 100;

  //   // Clamp values (extra safety)
  //   sensor.xPercentages = Math.min(Math.max(xPercentage, 0), 100);
  //   sensor.yPercentages = Math.min(Math.max(yPercentage, 0), 100);

  //   console.log('Updated sensor:', sensor);
  // }

  onPowertrainSensorDragEnd(event: CdkDragEnd, sensor: any): void {
    // Get the drag position
    const { x, y } = event.source.getFreeDragPosition();

    // Locate the image element explicitly
    const sensorElement = event.source.element.nativeElement;
    const assetElement = sensorElement
      .closest(".powertrain-item")
      ?.querySelector("img") as HTMLElement;

    if (assetElement) {
      // Get image dimensions
      const imageWidth = assetElement.offsetWidth;
      const imageHeight = assetElement.offsetHeight;

      // Calculate percentage positions
      const xPercentage = (x / imageWidth) * 100;
      const yPercentage = (y / imageHeight) * 100;

      // Assign percentage positions to the sensor
      // sensor.xPercentages = xPercentage;
      sensor.xPercentageNet = (sensor.xPercentage || 0) + xPercentage;
      // sensor.yPercentages = yPercentage;
      sensor.yPercentageNet = (sensor.yPercentage || 0) + yPercentage;
    } else {
      console.error("Image element not found. Ensure the selector is correct.");
    }
    console.log(`OLD xyz: ${sensor.xPercentage}-${sensor.yPercentage}`);
    console.log(`NEW xyz: ${sensor.xPercentages}-${sensor.yPercentages}`);
    console.log(`NET xyz: ${sensor.xPercentageNet}-${sensor.yPercentageNet}`);
  }

  fetchPowertrainImages() {
    this.powerTrainImages = []; // set to empty so see loaders properly
    if (!this.powerTrainImages.length) this.powertrainImageLoader = true;
    this.powertrainService
      .fetchPowertrainImages(this.imagesUrl + "?type=piezeo")
      // .fetchPowertrainImages('http://localhost:7777/powertrain/powertrain-images?type=piezeo')
      .then((data: any) => {
        this.powerTrainImages = data.images;
      })
      .catch((err) => {
        this.service.showError("Failed to fetch powertrain images");
        this.snackBar.open(
          "Failed to fetch powertrain images",
          "error-snackbar"
        );
      })
      .finally(() => {
        this.powertrainImageLoader = false;
      });
  }

  openPowertrainNameModalBox() {
    this.openPowertrainNameModal = true;
  }

  inputpowertrainForm(data) {
    console.log(data);
    if (data == undefined) {
      console.log('Data undefined might be cancel')
      this.openPowertrainNameModal = false;
      return;
    } else {
      this.openPowertrainNameModal = false;
      this.powertrainName = data.name;
      this.savePowerTrainTemplate();
    }
  }
  closePowertrainNameModal() {
    this.openPowertrainNameModal = false;
  }

  uploadImage() {
    this.isUploadModalOpen = true;
  }

  openUploadModal() {
    this.isUploadModalOpen = true;
  }

  closeUploadModal() {
    this.isUploadModalOpen = false;
  }

  onUploadSuccess(response: any) {
    this.fetchPowertrainImages();
  }

  openSnackBar(message: string, class_name: string) {
    this.snackBar.open(message, "Close", {
      duration: 3000,
      panelClass: [class_name],
    });
  }

  onCancel() {
    this.router.navigate(['/device-reports'])
  }
}
